import { Component, OnInit } from '@angular/core';
import { IonNav, ModalController, Platform } from '@ionic/angular';
import { CookiesInfoComponent } from './cookies-info/cookies-info.component';
import { UrlExtendedService } from '@app/core/services/url-extended.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

declare let cordova: any;

@Component({
  selector: 'app-accept-terms-dialog',
  templateUrl: './accept-terms-dialog.page.html',
  styleUrls: ['./accept-terms-dialog.page.scss'],
})
export class AcceptTermsDialogPage implements OnInit {

  browserOptions: string = '';
  privacyPolicyUrl: string = '';
  termsUrl: string = '';

  private onDestroy = new Subject();

  constructor(
    private modalController: ModalController, 
    private nav: IonNav,
    private platform: Platform,
    private urlExtendedService: UrlExtendedService
  ) { }

  ngOnInit() {
    this.urlExtendedService.$privacyPolicyUrl.pipe(takeUntil(this.onDestroy))
    .subscribe(privacyPolicyUrl => this.privacyPolicyUrl = privacyPolicyUrl);
    
    this.urlExtendedService.$termsUrl.pipe(takeUntil(this.onDestroy))
    .subscribe(termsUrl => this.termsUrl = termsUrl);
  }

  accept() {
    this.modalController.dismiss();
  }

  openTerms() {
    if (this.platform.is('capacitor')) {
      var ref = cordova.InAppBrowser.open(this.termsUrl, '_blank', this.browserOptions);
    }
    else {
      window.open(this.termsUrl);
    }
  }

  openPrivacyPolicy() {
    if (this.platform.is('capacitor')) {
      var ref = cordova.InAppBrowser.open(this.privacyPolicyUrl, '_blank', this.browserOptions);
    }
    else {
      window.open(this.privacyPolicyUrl);
    }
  }

  navigateToCookiesInfo() {
    this.nav.push(CookiesInfoComponent);
  }

  setBrowserOptions() {
    this.browserOptions += 'closebuttoncaption=Stäng,';
    this.browserOptions += 'toolbarposition=top,';
    this.browserOptions += 'toolbartranslucent=no,';
    this.browserOptions += 'hidenavigationbuttons=yes,';
    this.browserOptions += 'toolbarcolor=#6eaed1,';
    this.browserOptions += 'closebuttoncolor=#ffc409,';
    this.browserOptions += 'location=no,';
  }

  ngOnDestroy() {
    this.onDestroy.next(null);
  }

}
